// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnnexeOverall {
  margin-top: 3%;
  margin-left: 3%;
  padding-right: 5%;
}

.important {
  color: red;
}

.AnnexeAform {
  width: 100%;
}

.AnnexeTitle {
  margin-left: 25%;
}

.styleForForm {
  width: 100%;
}

.AnnexeName {
  margin-top: 6%;
  display: flex;
  gap: 8%;
}

.AnnexeFather {
  margin-top: 3%;
}

.allInfoFather {
  margin-top: 2%;
  display: flex;
}

.nomPrenomDaron {
  display: flex;
  gap: 11px;
}

.DateNaissanceDaron {
  margin-top: 2%;
}

.inputAnnexe {
  margin-left: 15px;
}

.inputAnnexeLow {
  margin-left: 8px;
}

.villeNaissance {
  display: flex;
  gap: 12px;
}

.decePere {
  margin-top: 2%;
}

.dateDece {
  margin-top: 2%;
}

.AnnexeMother {
  margin-top: 2%;
}

.shitAboutMom {
  display: flex;
}

.nomPrenomDaronne {
  margin-top: 2%;
  display: flex;
  gap: 2%;
}

.momRow2 {
  display: flex;
  gap: 2%;
}

.meredece {
  margin-top: 2%;
}

.yesNo {
  display: flex;
  flex-direction: column;
  font-size: 15px;
}

.yesNoPackage {
  margin-top: 2%;
}

.schoolNumber {
  display: flex;
  gap: 4%;
  margin-top: 2%;
}

.textColumn {
  font-size: 14px;
}

.textColumnSmaller {
  font-size: 12px;
}

.what {
  margin-top: 2%;
}

.border {
  border: 1px solid #000; /* Inside borders */
  padding: 10px;
  text-align: center;
}

.importantBis {
  color: blue;
}

.txtAntecedent {
  font-size: 15px;
}

.nextButton {
  margin-top: 17%;
}`, "",{"version":3,"sources":["webpack://./src/pages/AnnexeA/AnnexeA.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,cAAA;EACD,aAAA;EACA,OAAA;AADH;;AAOA;EACI,cAAA;AAJJ;;AAOA;EACI,cAAA;EACA,aAAA;AAJJ;;AAQA;EACI,aAAA;EACA,SAAA;AALJ;;AAQA;EACI,cAAA;AALJ;;AAUA;EACI,iBAAA;AAPJ;;AAUA;EACI,gBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,SAAA;AAPJ;;AAUA;EACI,cAAA;AAPJ;;AAWA;EACI,cAAA;AARJ;;AAWA;EACI,cAAA;AARJ;;AAWA;EACI,aAAA;AARJ;;AAWA;EACI,cAAA;EACA,aAAA;EACA,OAAA;AARJ;;AAWA;EACI,aAAA;EACA,OAAA;AARJ;;AAWA;EACI,cAAA;AARJ;;AAWA;EACI,aAAA;EACA,sBAAA;EAEA,eAAA;AATJ;;AAYA;EACI,cAAA;AATJ;;AAYA;EACI,aAAA;EACA,OAAA;EACA,cAAA;AATJ;;AAYA;EACI,eAAA;AATJ;;AAYA;EACI,eAAA;AATJ;;AAYA;EACI,cAAA;AATJ;;AAYA;EACI,sBAAA,EAAA,mBAAA;EACA,aAAA;EACA,kBAAA;AATJ;;AAYA;EACI,WAAA;AATJ;;AAYA;EACI,eAAA;AATJ;;AAYA;EACI,eAAA;AATJ","sourcesContent":[".AnnexeOverall{\n    margin-top: 3%;\n    margin-left: 3%;\n    padding-right: 5%;\n    //background-color: orange;\n}\n\n.important{\n    color: red;\n}\n\n.AnnexeAform{\n    width: 100%;\n\n}\n\n.AnnexeTitle{\n    margin-left: 25%;\n}\n\n.styleForForm{\n    width: 100%;\n}\n\n.AnnexeName{\n    margin-top: 6%;\n   display: flex;\n   gap: 8%;\n\n  \n  // flex-wrap: wrap; \n}\n\n.AnnexeFather{\n    margin-top: 3%;\n}\n\n.allInfoFather{\n    margin-top: 2%;\n    display: flex;\n   // gap:10%;\n}\n\n.nomPrenomDaron{\n    display: flex;\n    gap: 11px;\n}\n\n.DateNaissanceDaron{\n    margin-top: 2%;\n   // display: flex;\n   // gap:1%\n}\n\n.inputAnnexe{\n    margin-left: 15px;\n}\n\n.inputAnnexeLow{\n    margin-left: 8px;\n}\n\n.villeNaissance{\n    display: flex;\n    gap: 12px;;\n}\n\n.decePere{\n    margin-top: 2%;\n\n}\n\n.dateDece{\n    margin-top: 2%;\n}\n\n.AnnexeMother{\n    margin-top: 2%;\n}\n\n.shitAboutMom{\n    display: flex;\n}\n\n.nomPrenomDaronne{\n    margin-top: 2%;\n    display: flex;\n    gap: 2%;\n}\n\n.momRow2{\n    display: flex;\n    gap: 2%;\n}\n\n.meredece{\n    margin-top: 2%;\n}\n\n.yesNo{\n    display: flex;\n    flex-direction: column;\n    //margin-top: 2%;\n    font-size: 15px;\n}\n\n.yesNoPackage{\n    margin-top: 2%;\n}\n\n.schoolNumber{\n    display: flex;\n    gap: 4%;\n    margin-top: 2%;\n}\n\n.textColumn{\n    font-size: 14px;\n}\n\n.textColumnSmaller{\n    font-size: 12px;\n}\n\n.what{\n    margin-top: 2%;\n}\n\n.border {\n    border: 1px solid #000; /* Inside borders */\n    padding: 10px;\n    text-align: center;\n}\n\n.importantBis{\n    color: blue;\n}\n\n.txtAntecedent {\n    font-size: 15px;\n}\n\n.nextButton{\n    margin-top: 17%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
